/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_InfoInputs */

const en_student_info = /** @type {(inputs: Student_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Info`)
};

const he_student_info = /** @type {(inputs: Student_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פרטים`)
};

/**
* | output |
* | --- |
* | "Info" |
*
* @param {Student_InfoInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const student_info = /** @type {((inputs?: Student_InfoInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_InfoInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_student_info(inputs)
	return he_student_info(inputs)
});